module.exports = __webpack_public_path__ + "img/Najarian.f0ed7f4e.png";